import { useDispatch, useSelector } from 'react-redux';

/**
 * Single "All products" chip (Hide category filter #154/5001).
 * Selected (`categoryFilter === 'x'`) shows the flat product list;
 * unselected shows collection browse. Toggle via click.
 */
export default function Categories() {
	const dispatch = useDispatch();
	const categoryFilter = useSelector((state) => state.cart.categoryFilter);
	const accountType = useSelector((state) => state.auth.accountType);

	const isSelected = categoryFilter === 'x';

	const onToggle = () => {
		dispatch({ type: 'cart/setCategoryFilter', payload: 'x' });
	};

	if (accountType === 'parent') {
		return (
			<div className='grid-filter' role='toolbar' aria-label='Product categories'>
				<button
					type='button'
					className={isSelected ? 'on' : undefined}
					aria-pressed={isSelected}
					onClick={onToggle}
				>
					All products
				</button>
			</div>
		);
	}

	return (
		<div className='flex w-full gap-4'>
			<button
				type='button'
				className={
					isSelected
						? 'px-4 py-2 rounded-sm bg-black text-white'
						: 'px-4 py-2 rounded-sm bg-white border border-black'
				}
				aria-pressed={isSelected}
				onClick={onToggle}
			>
				All products
			</button>
		</div>
	);
}
